export const RoutePaths = {
  account: '/account',
  BLOG: '/blog',
  changePassword: '/change-password',
  contact: '/contact',

  docs: '/docs',
  DOCS_GETTING_STARTED_DOWNLOAD: 'getting-started/download', // must prefix /docs if linking from outside /docs route
  DOCS_GETTING_STARTED_CREATE_ACCOUNT: 'getting-started/create-account', // must prefix /docs if linking from outside /docs route
  DOCS_GETTING_STARTED_INITIAL_SETUP: 'getting-started/initial-setup', // must prefix /docs if linking from outside /docs route
  DOCS_GETTING_STARTED_HOME_SCREEN: 'getting-started/home-screen', // must prefix /docs if linking from outside /docs route

  DOCS_GARDENS_SCREEN: 'gardens', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_VIEWER_SCREEN: 'gardens/viewer', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_CREATE_GARDEN: 'gardens/create-garden', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_DELETE_GARDEN: 'gardens/delete-garden', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_RECORD_NOTE: 'gardens/record-note', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_RENAME_GARDEN: 'gardens/rename-garden', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_RESIZE_GARDEN: 'gardens/resize-garden', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_VIEW_GARDEN_DIFFERENT_DAY: 'gardens/view-garden-on-different-day', // must prefix /docs if linking from outside /docs route
  DOCS_GARDENS_VIEW_RECORDS: 'gardens/view-records', // must prefix /docs if linking from outside /docs route

  DOCS_PLANS_SCREEN: 'garden-plans', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_VIEWER_SCREEN: 'garden-plans/viewer', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_CREATE_PLAN: 'garden-plans/create-garden-plan', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_RENAME_PLAN: 'garden-plans/rename-garden-plan', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_COPY_PLAN: 'garden-plans/copy-garden-plan', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_DELETE_PLAN: 'garden-plans/delete-garden-plan', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_RESIZE_PLAN: 'garden-plans/resize-garden', // must prefix /docs if linking from outside /docs route
  DOCS_PLANS_SUMMARY: 'garden-plans/summary', // must prefix /docs if linking from outside /docs route

  DOCS_BEDS_ADD_BED: 'beds/add-bed', // must prefix /docs if linking from outside /docs route
  DOCS_BEDS_MOVE_RESIZE: 'beds/move-or-resize', // must prefix /docs if linking from outside /docs route
  DOCS_BEDS_RECORD_NOTE: 'beds/record-note', // must prefix /docs if linking from outside /docs route
  DOCS_BEDS_REMOVE_BED: 'beds/remove-bed', // must prefix /docs if linking from outside /docs route
  DOCS_BEDS_RENAME_BED: 'beds/rename-bed', // must prefix /docs if linking from outside /docs route
  DOCS_BEDS_VIEW_RECORDS: 'beds/view-records', // must prefix /docs if linking from outside /docs route
  DOCS_BEDS_VIEW_SQUARE_RECORDS: 'beds/view-square-records', // must prefix /docs if linking from outside /docs route

  DOCS_PLANTINGS_ADD_PLANTING: 'plantings/add-planting', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_COPY_PLANTING: 'plantings/copy-planting', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_MOVE_PLANTING: 'plantings/move-planting', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_GROWING_DATES: 'plantings/growing-dates', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_PROGRESS_BAR: 'plantings/progress-bar', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_RECORD_HARVEST: 'plantings/record-harvest', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_RECORD_NOTE: 'plantings/record-note', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_REMOVE_PLANTING: 'plantings/remove-planting', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_REMOVE_ALL_BED_PLANTINGS: 'plantings/remove-bed-plantings', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_REMOVE_ALL_SQUARE_PLANTINGS: 'plantings/remove-square-plantings', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_VIEW_RECORDS: 'plantings/view-records', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTINGS_VIEW_VARIETY_INFO: 'plantings/view-variety-information', // must prefix /docs if linking from outside /docs route

  DOCS_PLANTCATALOG_SCREEN: 'plant-catalog', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTCATALOG_PLANTS_AND_VARIETIES: 'plant-catalog/plants-and-varieties', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTCATALOG_GROWING_CALENDARS: 'plant-catalog/growing-calendars', // must prefix /docs if linking from outside /docs route
  DOCS_PLANTCATALOG_GROWING_INFORMATION: 'plant-catalog/growing-information', // must prefix /docs if linking from outside /docs route

  DOCS_SETTINGS_SCREEN: 'settings', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_THEME: 'settings/theme', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_PLANTING_PROGRESS: 'settings/show-plant-progress', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_GRID_LINES: 'settings/show-grid-lines', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_COUNTRY: 'settings/country', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_ZONE: 'settings/zone', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_FROST_DATES: 'settings/custom-frost-dates', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_UNITS: 'settings/use-metric-units', // must prefix /docs if linking from outside /docs route
  DOCS_SETTINGS_PLANTSPACING: 'settings/plant-spacing', // must prefix /docs if linking from outside /docs route

  DOCS_ACCOUNT_SCREEN: 'account', // must prefix /docs if linking from outside /docs route
  DOCS_ACCOUNT_CHANGE_PASSWORD: 'account/change-password', // must prefix /docs if linking from outside /docs route
  DOCS_ACCOUNT_DELETE_ACCOUNT: 'account/delete-account', // must prefix /docs if linking from outside /docs route
  DOCS_ACCOUNT_MANAGE_SUBSCRIPTION: 'account/manage-subscription', // must prefix /docs if linking from outside /docs route

  DOCS_SUPPORT_REPORT_BUG: 'support/report-bug', // must prefix /docs if linking from outside /docs route
  DOCS_SUPPORT_REQUEST_FEATURE: 'support/request-feature', // must prefix /docs if linking from outside /docs route
  DOCS_SUPPORT_REQUEST_PLANT: 'support/request-plant-or-variety', // must prefix /docs if linking from outside /docs route

  linkExpired: '/link-expired',
  login: '/login',
  pricing: '/pricing',
  PRIVACY: '/privacy-policy',
  register: '/register',
  RELEASE_NOTES: '/release-notes',
  resend: '/resend',
  reset: '/reset',
  terms: '/terms-and-conditions',
  verified: '/verified',
} as const;

export const ExternalLinks = {
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=app.croppa.app',
  APPLE_APPSTORE: 'https://apps.apple.com/us/app/croppa/id6743822052',
};
